import React from 'react';


export const EC2 = props => {
    return (
        <img className={props.className} src={require('../../../../resources/images/aws_icons/ec2.png')} />
    )
};
